import React, { useMemo, useState } from 'react';
import { InlineSelect } from '@ui/molecules/inputs/inline/InlineSelect';
function normalizeOption(option) {
    if (Array.isArray(option)) {
        const [label, value] = option;
        return { label: String(label), value: String(value) };
    }
    return { label: String(option.label), value: String(option.value) };
}
/**
 * React island that renders a Quimby InlineSelect inside a Rails form. The
 * selected value is mirrored to a hidden `<input>` so the surrounding form
 * submits the current selection on POST — no client-side AJAX required.
 *
 * @example (ERB)
 *   <%= react_component 'Forms/InlineSelectField', {
 *     name:         'frequency_schedule[monthly][day_of_month]',
 *     options:      day_of_month_toggle_options,
 *     initialValue: isf&.day_of_month || 1
 *   } %>
 */
function InlineSelectField({ name, options, initialValue, label, disabled = false }) {
    const normalized = useMemo(() => options.map(normalizeOption), [options]);
    const [value, setValue] = useState(String(initialValue));
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "hidden", name: name, value: value }),
        React.createElement(InlineSelect, { options: normalized, value: value, onChange: setValue, label: label, disabled: disabled })));
}
export default InlineSelectField;
